'use client';

import 'BomdisoftComponents/layout/styles.css';
import { LayoutContentSlot } from 'BomdisoftComponents/layout/content-slot';
import { LayoutProvider } from 'BomdisoftComponents/layout/context';
import { LayoutDrawerSlot } from 'BomdisoftComponents/layout/drawer-slot';
import { useCloseDrawersOnNavigation } from 'BomdisoftComponents/layout/hooks';
import { LayoutNavigationSlot } from 'BomdisoftComponents/layout/navigation-slot';
import { type BomdisoftLayoutProps } from 'BomdisoftComponents/layout/types';
import { type ReactElement } from 'react';

const LayoutInner = ({ children, drawers, hideNavbar, navPosition = 'bottom', navigation }: BomdisoftLayoutProps) => {
  useCloseDrawersOnNavigation();
  const showNav = !hideNavbar;

  return (
    <div className='bomdisoft-layout' data-nav={navPosition}>
      {showNav && <LayoutNavigationSlot>{navigation}</LayoutNavigationSlot>}
      <div className='bomdisoft-layout-middle-row'>
        <LayoutContentSlot>{children}</LayoutContentSlot>
        {drawers?.map(drawer => {
          const drawerId = (drawer as ReactElement<{ drawerId: string }>).props.drawerId;
          return (
            <LayoutDrawerSlot drawerId={drawerId} key={drawerId}>
              {drawer}
            </LayoutDrawerSlot>
          );
        })}
      </div>
    </div>
  );
};

export const BomdisoftLayout = (props: BomdisoftLayoutProps) => {
  return (
    <LayoutProvider defaultSidebarOpen={props.defaultSidebarOpen}>
      <LayoutInner {...props} />
    </LayoutProvider>
  );
};
